import type { IconData } from '@stacksjs/iconify-core'

export const codepen: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M10.549.26a1.56 1.56 0 0 0-1.756.02L.928 5.76c-.42.292-.67.77-.67 1.282v5.903c0 .525.264 1.014.702 1.303l7.994 5.285a1.56 1.56 0 0 0 1.723 0l8.153-5.386c.438-.29.701-.78.701-1.304v-5.8c0-.524-.263-1.013-.7-1.303zm6.09 6.393l-3.014 2.023l-2.826-2.055l-.018-4.042l5.857 4.074zm-7.902-4.07V6.54L5.84 8.564L2.953 6.627zM2.16 8.576l1.87 1.253l-1.87 1.308zm6.625 8.433L2.954 13.1l2.913-2.037l2.92 1.958v3.99zM7.68 9.796l1.888-1.32l2.2 1.445l-1.95 1.31zm3.167 7.213v-3.99l2.79-1.87l3.003 1.975zm6.625-5.805l-1.98-1.3l1.98-1.329z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default codepen
